export default __webpack_public_path__ + "static/media/img_12.a2d39453.jpg";